/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */
export const generatedApiVersion = "0.5.0";
